module.exports = __webpack_public_path__ + "Flag-226.5009417765931587cfcac12d4c1caa09.svg";